export default "__VITE_ASSET__mylPps3t__"